// Onboarding asset overrides
import onboardingonboardingScreenBg from 'assets/cigna-feature-background.svg';
import journeyHeaderBackground from 'assets/journey-header-background.svg';
import journeyHeaderEmptyStateHistory from 'assets/journey-header-empty-state-history.svg';
import error from 'assets/error-2.svg';
import exitWarning from 'assets/exit-warning.svg';

const JOURNEY_ASSETS = {
  JOURNEY_HEADER_BACKGROUND_IMAGE: journeyHeaderBackground,
  EMPTY_STATE_HISTORY: journeyHeaderEmptyStateHistory,
  WAVE_GOODBYE: exitWarning,
};

const ONBOARDING_ASSETS = {
  FEATURE_HIGHLIGHT_BACKGROUND: onboardingonboardingScreenBg,
};

const CLAIMS_ASSETS = {
  CLAIMS_LIST_EMPTY: error,
};

export const ASSETS_CONFIG = {
  ...JOURNEY_ASSETS,
  ...ONBOARDING_ASSETS,
  ...CLAIMS_ASSETS,
};
